import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  notificationList: [],
  notificationDetailList: [],
  notificationDetail: [],
  notificationSystemDetail: [],
  notificationSystemList: [],
  loading: false,
  error: undefined,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchNotificationList(state, action) {
      state.notificationList = action.payload;
      state.loading = false;
    },
    fetchNotificationListDetails(state, action) {
      state.notificationDetailList = action.payload;
      state.loading = false;
    },
    fetchNotificationSyeDetail(state, action) {
      state.notificationSystemDetail = action.payload;
      state.loading = false;
    },
    fetchNotificationSystemList(state, action) {
      state.notificationSystemList = action.payload;
      state.loading = false;
    },
    fetchNotificationDetail(state, action) {
      state.notificationDetail = action.payload;
      state.loading = false;
    },
  },
});

export const notificationActions = notificationSlice.actions;

export default notificationSlice.reducer;
